
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  FreelancerCharterResource,
} from '../models';
import {
    FreelancerCharterResourceFromJSON,
    FreelancerCharterResourceToJSON,
} from '../models';

export interface GetFreelancerCharterRequest {
    profileId: string;
}

/**
 * 
 */
export class FreelancerCharterApi extends runtime.BaseAPI {

    /**
     * Retrieve freelancer charter details 
          */
    async getFreelancerCharterRaw(requestParameters: GetFreelancerCharterRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerCharterResource>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getFreelancerCharter().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerCharterResource>({
            path: `/profile/api/freelancer-charter/{profileId}`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerCharterResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve freelancer charter details 
          */
    async getFreelancerCharter(requestParameters: GetFreelancerCharterRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerCharterResource> {
        const response = await this.getFreelancerCharterRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Sign freelancer charter 
          */
    async signRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/profile/api/freelancer-charter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Sign freelancer charter 
          */
    async sign(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.signRaw(initOverrides);
    }

}
